<template>
  <div class="wrapRule" style="background:rgb(250, 245, 230);padding-bottom:123px;widht:100%;overflow: hidden;">
    <gc-loading :is-show="loadingShow" />
    <gc-guide :down-show="downShow" @showDwon="getWechat" />
    <div class="banner">
      <img src="https://static.mingchu.co/webapp/xintan/ruleBanner.png" alt="">
    </div>
    <div class="participate">
      <img src="https://static.mingchu.co/webapp/xintan/howbot.png" alt="">
    </div>
    <div class="winning">
    <div class="winningTitle"><img src="https://static.mingchu.co/webapp/xintan/winning.png" alt=""></div>
      <div class="winningCent">
        <Reward />
      </div>
    </div>
    <div class="task">
      <div class="taskTitle"><img src="https://static.mingchu.co/webapp/xintan/challenge.png" alt=""></div>
      <ul>
        <li>
          <div class="tasktop"><img src="https://static.mingchu.co/webapp/xintan/challenge1.png" alt=""></div>
          <div class="taskbot">
            <div>邀请助力</div>
            <div>分享链接，邀好友加持「名厨力」</div>
          </div>
        </li>
        <li>
          <div class="tasktop"><img src="https://static.mingchu.co/webapp/xintan/challenge2.png" alt=""></div>
          <div class="taskbot">
            <div>每日任务</div>
            <div>打卡每日任务，角逐探店名额</div>
          </div>
        </li>
        <li>
          <div class="tasktop"><img src="https://static.mingchu.co/webapp/xintan/challenge3.png" alt=""></div>
          <div class="taskbot">
            <div>试用挑战</div>
            <div>参与试用，赢米其林发布庆典门票</div>
          </div>
        </li>
      </ul>
    </div>
    <BottomLogo />
    <div class="footer">
      <div v-if="Number(new Date())/1000<Number(sign.end_time)" class="footTitle">立即报名参与活动，获取限时头像挂件</div>
      <div class="footbtn">
        <img src="https://static.mingchu.co/webapp/findNew/imgs/help.png" alt="" @click="question">
        <div v-if="Number(new Date())/1000<Number(sign.end_time)&&sign.sign_status!=1" @click="Signup(1)">立即报名</div>
        <div v-else @click="Signup(2)">查看活动详情</div>
      </div>
      <div v-if="isFull" style="height:34px" />
    </div>
  </div>
  <ActionSheet
    :rule-show="ruleShow"
    @onCancel="ruleCancel"
  />
  <van-popup :show="obtainShow" custom-style="border-radius: 4px;">
    <div class="rulePopup">
      <div class="popupIcon" @click="Signup(2)" />
      <div class="popupTitle">
        <div>恭喜您已获得此头像挂件</div>
        <div> 并为您佩戴成功！</div>
      </div>
      <div style="color:#999999;font-size: 12px;"> App 需要升级至最新版本</div>
      <div class="frame">
        <img style="border-radius:50%;width:90px;height:90px;" :src="sign.head_pic_url" alt="">
        <img style="position:absolute;" src="https://static.mingchu.co/webapp/xintan/frame.png" alt="">
      </div>
      <div class="popupText">继续挑战，冲刺排行榜！赢杭州米其林指南发布庆典门票&杭州探店机会</div>
      <div class="Challenge" @click="Signup(2)">继续挑战</div>
    </div>
  </van-popup>
  <ShareInfo :share-info="shareInfo" />

</template>

<script setup>
import { ref, reactive } from 'vue'
import { Popup as vanPopup, Toast } from 'vant'
import {fullScreen } from '@/utils'

import { ajaxHttp } from '@/api/api'
import utils from '@/utils/utils'
import config from '@/config/config'
import { useRouter } from 'vue-router'
import BottomLogo from '../components/BottomLogo'
import Reward from '../components/Reward'

import ShareInfo from '@/components/shareInfo.vue'

import ActionSheet from '../components/ActionSheet'
const ruleShow = ref(false)
const loadingShow = ref(true)
const obtainShow = ref(false)
const isFull = ref(fullScreen())

const downShow = ref(false)
const sign = ref({})
let shareInfo = reactive({ share_title: '', share_desc: '', share_img: '', share_link: '' })
const router = useRouter()
const getDataInfo = () => { // 获取详情数据
  ajaxHttp.$get(`/api/explore/index`).then(res => {
    if (res.code === 1) {
      shareInfo.share_link = `${config.webapplink}/riseActivity/xintan/xinshare?id=${res.data.uid}`
      sign.value = res.data
      if (res.data.sign_status) {
        router.replace({ path: '/riseActivity/xintan/xinhome', query: { top: '1' }})
      }else{
        loadingShow.value = false
      }
    } else {
      Toast(res.message)
    }
  })
}
const getShareData = () => {
  ajaxHttp.$get(`/api/explore/share_info`).then(res => {
    if (res.code === 1) {
      shareInfo = res.data
      getDataInfo()
    } else {
      Toast(res.message)
    }
  })
}
getShareData()
const ruleCancel = () => {
  ruleShow.value = false
}
const question = () => {
  ruleShow.value = true
}
const Signup = (type) => {
  if (!utils.isGteatChefbrowser()) {
    const u = navigator.userAgent
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
    if (utils.is_weixn()) {
      if (!isAndroid) {
        utils.goDown('H5', `${config.webapplink}/riseActivity/xintan/xinrule`)
      } else {
        downShow.value = true
      }
    } else {
      utils.goDown('H5', `${config.webapplink}/riseActivity/xintan/xinrule`)
    }
  } else {
     utils.isLogin().then(res_login => { // app登陆状态
        const resLogin = JSON.parse(res_login)
        if (resLogin.data.is_login === 1) { // 登陆成功
          if (type === 1) {
            ajaxHttp.$post(`/api/explore/sign`).then(res => {
              if (res.code === 1) {
                obtainShow.value = true
              } else {
                Toast(res.message)
              }
            })
          } else {
            router.replace({ path: '/riseActivity/xintan/xinhome', query: { top: '1' }})
          }
        } else { // 没登录跳登录
            if (utils.isAndroid()) {
              location.href = `${config.webapplink}/login`
            } else {
              utils.login().then(res => {
                location.reload()
              })
            }
          }
      })
  }
}
</script>

<style lang="scss" scoped>
.participate{
  position: relative;top:-18px; margin: 0 9px;border-radius: 2px;
  .participateTitle{display:flex;justify-content:center;margin-bottom:16px;
    img{width: 136.5px;height: 27px;}
  }
  .participatebot{width: 100%;height: 100%;}
}
.winning{
  background: #FFFFFF;margin: -5px 9px 0 9px;border-radius: 2px;padding:0 0px 8px 0; position:relative;
  .winningTitle{
    img{width: 100%;}
  }
  .winningCent{padding:0 14px 10px 14px;margin-top:-36px;}
}
.task{margin: 16px 9px 0 9px;border-radius: 2px;background: #FFFFFF;
  .taskTitle{
    img{width: 100%;}
  }
  ul{height: 128px;margin:-22px 15px 0 15px;display:flex;align-items:center;justify-content:space-between;padding:0 0 14px 0;
    li{width:100px;
      .tasktop{display:flex;justify-content:center;
        img{width:64px;height:64px;}
      }
      .taskbot{
        div:first-child{color: #333333;font-size: 14px;font-weight:bold;text-align:center;padding:8px 0 4px 0;}
        div:last-child{color: #333333;font-size: 12px;text-align:center;}
      }
    }
  }
  }
.footer{width: 100%;background: #fff;position:fixed;bottom:0;z-index:99;
  .footbtn{width: 100%;display: flex;
    img{width:26.67px;height: 26.67px;border-radius: 50%;margin-left:42.67px;margin-top: 18.67px;}
    div{width: 257px;height: 48px;background:#C99700;border-radius: 2px; text-align: center;line-height: 48px;font-size: 16px;font-weight: bold;color: #fff;margin: 8px 24px 8px 24px;}
  }
  .footTitle{width: 100%;height: 26px;background: #E6D690;color: #333333;;font-size: 12px;text-align:center;line-height:26px;}
}
.rulePopup{
  width:327px;text-align:center;
  .popupTitle{font-weight: bold;font-size: 24px;color: #333333;margin-top:40px;}
  .frame{width:200px;height:200px;margin-left:63.5px;border: 1px solid #F9F8F8;border-radius: 4px;background: #F9F8F8;margin-top:10px;display:flex;justify-content:center;align-items:center;
    img{width: 92px;height: 92px;}
  }
  .Challenge{width: 279px;height: 48px;background: #C99700;border-radius: 2px;color: #FFFFFF;font-weight: bold;font-size: 16px;line-height:48px;margin:14px 0 24px 24px;}
  .popupText{width:280px;margin:16px 0 0 24px;color: #999997;font-size: 16px;line-height: 24px;}
  .popupIcon{width: 28px;height: 28px;position:absolute;top:8px;right:11.5px;background-size:28px;;background-image: url("data:image/svg+xml,%3Csvg width='29' height='28' viewBox='0 0 29 28' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M21.5 7L7.5 21M7.5 7L21.5 21' stroke='%23999999' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E ");}
}
</style>
